export default "__VITE_ASSET__CIKGeK7j__"